import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { RULES_CONFIG_ROUTE_PATHS, RULES_CONFIG_SCOPE } from './config';

export const RULES_CONFIG_ROUTES: TApplicationRoute[] = [
  {
    id: 'rules-config',
    path: RULES_CONFIG_ROUTE_PATHS.rulesConfig,
    component: lazy(() => import('./pages/rules-config-page')),
    layout: 'default',
    permissions: { scopes: [RULES_CONFIG_SCOPE] },
    menu: {
      title: 'Rules Config',
    },
  },
];
